import React from 'react';
import { StringParam, useQueryParam } from 'use-query-params';
import useProjectIdState from './Hooks/useProjectIdState';
import { GlobalStoreContext, GlobalStoreContextProps } from './useGlobalStoreContext';

export default function GlobalStoreContextProvider({ children }: { children: React.ReactNode }) {
  const { projectId, rawProjectId } = useProjectIdState();
  const [queryStringSearch, setQueryStringSearch] = useQueryParam('displayId', StringParam);
  const value: GlobalStoreContextProps = React.useMemo(() => ({
    projectId,
    rawProjectId,
    displayId: [queryStringSearch, (val: string | null) => { setQueryStringSearch(val, 'replaceIn'); }],
  }), [projectId, rawProjectId, queryStringSearch]);

  return (
    <GlobalStoreContext.Provider value={value}>
      {children}
    </GlobalStoreContext.Provider>
  );
}
